




















import { Component, Vue } from "vue-property-decorator";

@Component
export default class ProgressCircular extends Vue {
  dialog = false;

  showProgress(): void {
    this.dialog = true;
  }

  hiddenProgress(): void {
    this.dialog = false;
  }
}
